import { useImperativeHandle, forwardRef, useState, useEffect } from "react";

import { ChevronDownIcon } from "@heroicons/react/24/outline";

type MySelectProps = {
  options: [string, string][];
  defaultValue?: string;
  name?: string;
  onChange?: (event: {
    target: { value: string; name: string };
    type: string;
  }) => void;
};

// Type for the ref object that react-hook-form expects
type SelectRef = {
  value: string;
  name?: string;
};

const MyOtherSelect = forwardRef<SelectRef, MySelectProps>(
  ({ options, defaultValue = "", name, onChange }, ref) => {
    const [value, setValue] = useState(defaultValue);
    const [showContentMenu, setShowContentMenu] = useState(false);

    // Update value when defaultValue changes
    useEffect(() => {
      setValue(defaultValue);
    }, [defaultValue]);

    useImperativeHandle(ref, () => ({
      value,
      name: name || "", // optional for RHF registration
    }));

    const handleChange = (newVal: string) => {
      setValue(newVal);
      // Call the onChange function from react-hook-form with a synthetic event
      if (onChange) {
        // Create a synthetic event object that react-hook-form expects
        const syntheticEvent = {
          target: {
            value: newVal,
            name: name || "",
          },
          type: "change",
        };
        onChange(syntheticEvent);
      }
    };

    const prettyValue =
      options.find(([val]) => val === value)?.[1] || "Set a value";

    return (
      <div className="flex items-center gap-2">
        <div className="relative">
          <button
            type="button"
            onClick={() => setShowContentMenu((prev) => !prev)}
            className="flex items-center text-sm px-2 py-1 rounded-full border border-gray-300 hover:bg-gray-100 gap-1"
          >
            {prettyValue}
            <ChevronDownIcon className="h-4 w-4 text-gray-400" />
          </button>
          {showContentMenu && (
            <div className="absolute right-0 mt-2 bg-white border border-gray-200 rounded-md shadow-md z-10">
              {options.map((type) => (
                <button
                  key={type[0]}
                  onClick={() => {
                    handleChange(type[0]);
                    setShowContentMenu(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                >
                  {type[1]}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default MyOtherSelect;
